import { getActivePinia } from 'pinia';

// Create Pinia instance with Vue 3.5 compatibility
const pinia = getActivePinia();

// Export stores for easy importing
export { useAuthStore } from './authStore.js';
//export { useProfileStore } from './profileStore.js';

export { useLanguageStore } from './useLanguageStore.js';
export { useNotificationStore } from './notificationStore.js';
export { useRealtimeStore, REALTIME_STATUS } from './realtimeStore.js';

export default pinia;
